<template>
  <div>
    <ChatModalPopup
      ref="popupWindow"
      id="first-popup"
      :chatMsgs="popupWindow[0].usr"
      @popupOpen="$emit('popupOpen')"
      @popupClose="closeFirst"
      :class="{ 'right-open': isOpen }"
    />
    <ChatModalPopup
      ref="popupWindow1"
      id="second-popup"
      :chatMsgs="popupWindow[1].usr"
      class="second-popup"
      :class="[{ 'second-popup': !isOpen }, { 'right-open-second': isOpen }]"
      @popupOpen="$emit('popupOpen')"
      @popupClose="closeSecond"
    />
    <ChatModalPopup
      ref="popupWindow2"
      id="third-popup"
      :chatMsgs="popupWindow[2].usr"
      class="third-popup"
      :class="[{ 'third-popup': !isOpen }, { 'right-open-third': isOpen }]"
      @popupOpen="$emit('popupOpen')"
      @popupClose="closeThird"
    />
  </div>
</template>

<script>
import ChatModalPopup from "@/components/molecules/ChatModalPopup";
import ChatHelperVue from "../mixins/ChatHelper.vue";
import UserHelperVue from "../mixins/UserHelper.vue";
import Auth from "@/modules/Auth.js";

import { UNREAD } from "@/enum/message-seen";

export default {
  name: "RightStickyBar",
  components: {
    ChatModalPopup,
  },
  props: ["messages"],
  mixins: [ChatHelperVue, UserHelperVue],
  data() {
    return {
      popupWindow: [
        { on: 0, usr: {} },
        { on: 0, usr: {} },
        { on: 0, usr: {} },
      ],
      filter: "",
      usrCounter: 0,
      isOpen: false,
      system_notification: {
        firstName: "Swampum",
        id: -1,
        messages: [],
      },
      notificationIds: [],
      unseenMsgIds: [],
    };
  },
  watch: {
    systemNotification() {
      if (this.systemNotification.length > 0) {
        this.systemNotification.forEach((element) => {
          this.system_notification.messages.push({
            createdAt: element.createdAt,
            id: element.id,
            read: element.read,
            type: element.type,
            msg: element.message,
            senderId: element.receiverId,
            receiverId: -1,
          });
          this.notificationIds.push(element.id);
        });
        this.openClosePopup(-1);
        this.setReadNotification({ notificationIds: this.notificationIds });
      }
    },
    messages(newValue) {
      if (newValue) {
        if (this.$refs.popupWindow.isActive) {
          this.updateChat(0, newValue);
        }
        if (this.$refs.popupWindow1.isActive) {
          this.updateChat(1, newValue);
        }
        if (this.$refs.popupWindow2.isActive) {
          this.updateChat(2, newValue);
        }
      }
    },
    popupWindow: {
      deep: true,
      handler(){
        this.saveLocalStorage();
      }
    },
  },
  methods: {
    checkIfHasChat(){
      if (localStorage.getItem("chatModalStatus") &&
      JSON.parse(localStorage.getItem("chatModalStatus")) !== null) {
        this.popupWindow =  JSON.parse(localStorage.getItem("chatModalStatus")); 
      }
      this.popupWindow.forEach((element, i) => {
        this.openTheGates(i);
      });
    },
    updateChat(chatId, newValue) {
      const id = this.popupWindow[chatId].usr.key?.id;
      const partner = {
        ...this.popupWindow[chatId].usr.partner,
      };
      let conversation = newValue.find((item) => item.key.id === id);
      //CHECK: quando é a primeira conversa, a conversation vem undefined, verificar
      this.popupWindow[chatId].usr = {
        isOpen: true,
        key: { ...conversation.key },
        messages: [...conversation.messages],
        partner: { ...partner },
        timestamp: conversation.timestamp,
        type: conversation.type,
      };
    },
    logout(event) {
      event.preventDefault();
      sessionStorage.clear();
      this.endSession();
      Auth.deauthenticateUser();
      this.$parent.$parent.clearLastInteraction();
      localStorage.removeItem("user_id");
      console.log("passei8");
      this.$route.path !== "/" && this.$router.push("/");
      location.reload();
    },
    checkOpenClosePopupId(id) {
      if (id === -1) return this.system_notification
      return this.chatMessages
    },
    openClosePopup(id = null) {
      let checkUser = this.checkOpenClosePopupId(id);

      this.popupWindow.forEach((element, i) => {
        let check = this.popupWindow.some((item) => {
          if (item.usr.key) {
            return item.usr.key.id === checkUser.key.id;
          } else return false;
        });
        if (
          check === false &&
          !element.on &&
          Object.keys(checkUser).length > 0 &&
          id !== -1
        ) {
          this.popupWindow[i].on = 1;
          this.popupWindow[i].usr = checkUser;
          if (window.innerWidth <= 840)
            this.popupWindow[2] = { on: 0, usr: {} };
          if (window.innerWidth <= 768)
            this.popupWindow[1] = { on: 0, usr: {} };
          this.getUnseenMsgs(checkUser.messages);
          this.openTheGates(i);
        } else if (id === -1 && check === false) {
          this.popupWindow[0].on = 1;
          this.popupWindow[0].usr = checkUser;
          this.openTheGates(i);
        }
      });
    },
    getUnseenMsgs(messages) {
      messages.forEach((message) => {
        if (message.seen === UNREAD) {
          this.unseenMsgIds.push(message.id);
        }
      });
    },
    closeFirst() {
      this.popupWindow[0].on = 0;
      this.popupWindow[0].usr = {};
      this.notificationIds = [];
      if (
        !this.$refs.popupWindow1.isActive &&
        !this.$refs.popupWindow2.isActive
      ) {
        this.$emit("allPopupClosed");
      }
    },
    closeSecond() {
      this.popupWindow[1].on = 0;
      this.popupWindow[1].usr = {};
      if (
        !this.$refs.popupWindow.isActive &&
        !this.$refs.popupWindow2.isActive
      ) {
        this.$emit("allPopupClosed");
      }
    },
    closeThird() {
      this.popupWindow[2].on = 0;
      this.popupWindow[2].usr = {};
      if (
        !this.$refs.popupWindow.isActive &&
        !this.$refs.popupWindow1.isActive
      ) {
        this.$emit("allPopupClosed");
      }
    },
    openTheGates(index) {
      if (index === 0) {
        if (this.popupWindow[0].on) this.$refs.popupWindow.open();
      } else if (index === 1) {
        if (this.popupWindow[1].on) this.$refs.popupWindow1.open();
      } else if (index === 2) {
        if (this.popupWindow[2].on) this.$refs.popupWindow2.open();
      }
    },
    perfectScrollbarInit() {
      const $chatContainer = $(".popup-chat-responsive .mCustomScrollbar");
      const $containers = $(".mCustomScrollbar");

      $containers.perfectScrollbar({ wheelPropagation: false });

      if (!$chatContainer.length) {
        return;
      }

      $chatContainer.scrollTop($chatContainer.prop("scrollHeight"));
      $chatContainer.perfectScrollbar("update");
    },
    saveLocalStorage(){
      localStorage.setItem("chatModalStatus", JSON.stringify(this.popupWindow));
    },
  },
  updated() {
    this.perfectScrollbarInit();
    $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip();
  },
  created() {
    window.addEventListener("click", (event) => {
      if (
        !$(event.target).closest(".fixed-sidebar").length &&
        $(".fixed-sidebar").is(":visible")
      ) {
        $(".fixed-sidebar").removeClass("open");
        this.isOpen = false;
      }
    });
  },
  mounted(){
    this.checkIfHasChat();
  }
};
</script>

<style lang="scss" scoped>
.second-popup {
  margin-right: 310px;
}
.third-popup {
  margin-right: 620px;
}
.profile-img {
  height: 34px;
  width: 34px;
}
@media screen and (max-width: 720px) {
  .second-popup {
    display: none;
  }
}
@media screen and (max-width: 1024px) {
  .third-popup {
    display: none;
  }
}
@media (min-width: 840px) {
  .right-open {
    margin-right: 220px;
  }
  .right-open-second {
    margin-right: 530px;
  }
  .right-open-third {
    margin-right: 840px;
  }
  .profile-img {
    height: 34px;
    width: 34px;
  }
  .form-group {
    border-style: solid;
    border-width: thin;
    color: #515365;
    width: 200px;
    left: 10px;
    text-align: center;
  }
  .points {
    text-align: center;
    color: #515365;
  }
}

@media only screen and (max-width: 375px) {
  #first-popup {
    left: 1%;
  }
}

.fixed-sidebar {
  display: none !important;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  width: fit-content;
}

@media only screen and (max-width: 768px) {
  .fixed-sidebar {
    display: flex !important;
  }
}

.search-button {
  fill: #ffffff;
  text-align: center;
  max-height: 70px;
  background: none;
  border: none;
}
</style>
